import { __ } from "../../locales/translation";

export default function VariationSelectors({ data }) {
    const { diaria, semana, meses1, meses6, meses12, ytd } = data || {};

    const dataArr = [
        {
            id: 1,
            label: `${__("Hoy")}`,
            value: diaria ? parseFloat(diaria?.toFixed(2)) : "-",
        },
        {
            id: 2,
            label: `${__("Semana")}`,
            value: semana ? parseFloat(semana?.toFixed(2)) : "-",
        },
        {
            id: 3,
            label: `${__("1 mes")}`,
            value: meses1 ? parseFloat(meses1?.toFixed(2)) : "-",
        },
        {
            id: 4,
            label: `${__("6 meses")}`,
            value: meses6 ? parseFloat(meses6?.toFixed(2)) : "-",
        },
        {
            id: 5,
            label: `${__("1 año")}`,
            value: meses12 ? parseFloat(meses12?.toFixed(2)) : "-",
        },
        {
            id: 6,
            label: `${__("YTD")}`,
            value: ytd ? parseFloat(ytd?.toFixed(2)) : "-",
        },
    ];

    return (
        <div className="variation-selectors">
            {dataArr.map((el) => {
                return (
                    <div key={el.id} className="variation-selector">
                        <div className="medium-text label">{el.label}</div>
                        <div
                            className={`medium-text value ${el.value < 0 && "--red"} ${el.value > 0 && "--green"} ${
                                el.value === 0 && "--neutral"
                            }`}
                        >
                            {/* {el.value < 0 && "-"} */}
                            {el.value}%
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
